export default __webpack_public_path__ + "static/media/phone.a12e695e.svg";